// 待維修藥盒 component

<template lang="pug">
  div
    div.upper-subpanel.row
      div.error-wrap
        div.disable-device-wrap
          div.disable-device(v-for="dev in disableDevices")
            p 藥盒位置：{{ dev.net.open_times }} - {{ dev.net.row_id }} - {{ dev.pos_row }} - {{ dev.relative_col }}
        div.hint-msg
          p.text-center 已鎖定藥盒清單。請將此畫面拍下，並與工程人員聯絡，謝謝！
    BottomButtons
      action-button(title="回主畫面" slot="button-1" @click.native="cancel")
      
</template>

<script>
import BottomButtons from './common/BottomButtons';

export default {
  name: 'DisableDevicesList',
  computed: {
    disableDevices() {
      return this.$store.getters.disableDevices;
    },
  },
  components: {
    BottomButtons,
  },
  mounted() {
    this.$store.commit('SET_APP', '待維修藥盒');
  },
  methods: {
    cancel() {
      this.$router.push({ name: 'Main' });
    },
  },
};
</script>

<style lang="sass">
.error-wrap
  width: 100%
  height: 100%
  position: relative

.disable-device-wrap
  width: 100%
  height: 90%
  display: flex
  overflow-x: scroll
  justify-content: center
  align-items: center
  flex-wrap: wrap
  flex-direction: column;

.disable-device
  width: 200px
  height: 50px
  border-radius: 10px
  margin: 10px
  background-color: red
  color: white
  box-shadow: 0 1px 5px rgba(0,0,0,.2), 0 2px 2px rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.12)
  display: flex
  justify-content: center
  align-items: center
  p
    margin: 0
.hint-msg
  width: 100%
  color: red
  bottom: 0
  position: absolute
</style>



// WEBPACK FOOTER //
// DisableDevicesList.vue?6c93e2dc